/*
 * Module for the MemberDirect Complete Profile page
*/
rs.module("content/user/completeprofile",

    ["common/select-helper"],

    function (selectHelper) {

        var defaultEntryKey = '00000000-0000-0000-0000-000000000000';

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, codeValues, backendUrls, authenticatorKey, authenticatorKeyLinkText) {

            var form = $.js(jsSelectors.form);

            var sendCodeButton = form.js(jsSelectors.sendCodeButton, { required: false, multiple: true });

            var questionOne = form.js(jsSelectors.challengeQuestionSelect1, { required: false });
            var questionTwo = form.js(jsSelectors.challengeQuestionSelect2, { required: false });

            if (questionOne.length > 0) {

                // Disable selected questions in select lists when page loads
                disableSelectedQuestionInOtherList();

                // Disable question 1 in Question 2's select list
                questionOne.change(disableSelectedQuestionInOtherList);

                // Disable question 2 in Question 1's select list
                questionTwo.change(disableSelectedQuestionInOtherList);

                // Helper function to disable a selected question in the other question's select list
                function disableSelectedQuestionInOtherList() {
                    selectHelper.getHelper(questionOne).enableAllOptions().disableOptions([questionTwo.val()]);
                    selectHelper.getHelper(questionTwo).enableAllOptions().disableOptions([questionOne.val()]);
                }
            }

            // Check the user's entered phone number when the page loads, 
            //and add input event to check phone number as input changes
            _checkPhoneNumber();
            form.js(jsSelectors.phoneNumberTextBox, { required: false }).on("input", _checkPhoneNumber);

            function _checkPhoneNumber() {

                // Only enable send code if they're giving us a 10 digit phone
                var reg = new RegExp("^\\(?\\d{3}\\)?[\\ xs.-]*\\d{3}[\\s.x-]*\\d{4}$");

                var phoneNumberTextBox = form.js(jsSelectors.phoneNumberTextBox, { required: false });
                var sendTextMessageCodeButton = form.js(jsSelectors.sendTextMessageCodeButton, { required: false });

                if (!phoneNumberTextBox.val() || !reg.test(phoneNumberTextBox.val().trim())) {
                    sendTextMessageCodeButton.prop("disabled", true);
                }
                else {
                    sendTextMessageCodeButton.prop("disabled", false);
                }
            }

            // Send a new verification code
            sendCodeButton.on("click", function () {

                var verificationType = form.js(jsSelectors.verificationMethodSelect).val();
                var phoneNumberTextBox = form.js(jsSelectors.phoneNumberTextBox, { required: false });
                var emailTextBox = form.js(jsSelectors.emailTextBox, { required: false });

                var verificationValue = verificationType == codeValues.SMS ? phoneNumberTextBox.val() : emailTextBox.val();

                var executedCall = $.getJSON(
                    backendUrls.sendMfaCode,
                    {
                        verificationType: verificationType,
                        verificationValue: verificationValue

                    }).done(function (data) {

                    // Update the verification code entry key
                    if (data.verificationCodeEntryKey != null && data.verificationCodeEntryKey != defaultEntryKey) {

                        form.js(jsSelectors.verificationEntryKeyHiddenInput).val(data.verificationCodeEntryKey);

                        // If we used a phone number, we'll receieve a formatted version
                        if (verificationType == codeValues.SMS) {

                            phoneNumberTextBox.val(data.formattedPhone);
                            form.js(jsSelectors.phoneNumberHiddenInput).val(data.formattedPhone);
                        }
                    }
                });

                _showCodeSentMessage(executedCall)
            });

            // Allow the user to see the auth key for 1 minute
            form.js(jsSelectors.showAuthKeyLink, { required: false }).click(function () {

                var authkeyLink = $(this);

                // We know our Authenticator Key has a length of 32. Insert a space every 4th character
                var formattedAuthKey = authenticatorKey.split('').reduce((a, e, i) => a + e + (i % 4 === 3 ? ' ' : ''), '');

                // Display the auth key
                $(this).fadeOut(function () {
                    authkeyLink.text(formattedAuthKey);
                    authkeyLink.fadeIn();
                });

                // In one minute, hide the auth key and show the text again.
                setTimeout(function () {
                    authkeyLink.fadeOut(function () {
                        authkeyLink.text(authenticatorKeyLinkText);
                        authkeyLink.fadeIn();
                    });
                }, 60000);
            });

            // They've changed their verification method - change the appearance of the Mfa section based on the newly selected method
            form.js(jsSelectors.verificationMethodSelect, { required: false }).change(function () {

                var verificationMethod = form.js(jsSelectors.verificationMethodSelect).val();

                // reset phone fields
                var phoneNumberTextBox = form.js(jsSelectors.phoneNumberTextBox, { required: false });
                var phoneNumberHiddenInput = form.js(jsSelectors.phoneNumberHiddenInput, { required: false });

                phoneNumberTextBox.prop("disabled", false);
                phoneNumberTextBox.val(null);
                phoneNumberHiddenInput.val(null);

                // reset veriication code fields
                form.js(jsSelectors.verificationCodeTextBox).val(null);
                form.js(jsSelectors.verificationEntryKeyHiddenInput).val(defaultEntryKey);

                var smsSection = form.js(jsSelectors.smsMfaSection, { required: false});
                var emailSection = form.js(jsSelectors.emailMfaSection, { required: false });
                var authenticatorSection = form.js(jsSelectors.authenticatorMfaSection, { required: false });
                var verificationCodeSection = form.js(jsSelectors.verificationCodeSection, { required: false });

                smsSection.addClass(cssClasses.hidden);
                emailSection.addClass(cssClasses.hidden);
                authenticatorSection.addClass(cssClasses.hidden);
                sendCodeButton.prop("disabled", true);
                verificationCodeSection.toggleClass(cssClasses.hidden, verificationMethod == "");

                if (verificationMethod == codeValues.SMS) {

                    smsSection.removeClass(cssClasses.hidden);
                }
                else if (verificationMethod == codeValues.Email) {

                    emailSection.removeClass(cssClasses.hidden);
                    sendCodeButton.prop("disabled", false);
                }
                else if (verificationMethod == codeValues.Authenticator) {

                    authenticatorSection.removeClass(cssClasses.hidden);
                }
            });

            // Show the a message after sending a new code
            var sendCodeMessageTimer;
            function _showCodeSentMessage(executedFunction) {

                executedFunction.done(function () {

                    sendCodeButton.html("&#10003; Sent");

                }).fail(function () {

                    sendCodeButton.html("Failed!");

                }).always(function () {

                    // Each time a new code is sent, we want to reset the timeout for showing the sent message
                    clearTimeout(sendCodeMessageTimer);

                    // Hide the message after 2 seconds
                    sendCodeMessageTimer = setTimeout(function () {

                        sendCodeButton.html("Send Code");
                    }, 2000);
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);